/* AUTO-GENERATED by scripts/generate-icon-registry.ts. DO NOT EDIT. */

import type { FC, SVGProps } from 'react';
import { ReactComponent as AddIcon } from 'ui/icons/add.svg';
import { ReactComponent as AddCircleIcon } from 'ui/icons/add-circle.svg';
import { ReactComponent as AddCircleFilledIcon } from 'ui/icons/add-circle-filled.svg';
import { ReactComponent as AddClassIcon } from 'ui/icons/add-class.svg';
import { ReactComponent as AddImgIcon } from 'ui/icons/add-img.svg';
import { ReactComponent as AiIcon } from 'ui/icons/ai.svg';
import { ReactComponent as AiGenerateIcon } from 'ui/icons/ai-generate.svg';
import { ReactComponent as AirplayIcon } from 'ui/icons/airplay.svg';
import { ReactComponent as AlarmIcon } from 'ui/icons/alarm.svg';
import { ReactComponent as AlarmOffIcon } from 'ui/icons/alarm-off.svg';
import { ReactComponent as AlertIcon } from 'ui/icons/alert.svg';
import { ReactComponent as AllClassIcon } from 'ui/icons/all-class.svg';
import { ReactComponent as AppsIcon } from 'ui/icons/apps.svg';
import { ReactComponent as ArchiveIcon } from 'ui/icons/archive.svg';
import { ReactComponent as Archive2Icon } from 'ui/icons/archive2.svg';
import { ReactComponent as ArrobaIcon } from 'ui/icons/arroba.svg';
import { ReactComponent as Arrow_ForwardIcon } from 'ui/icons/arrow_forward.svg';
import { ReactComponent as ArrowBackIcon } from 'ui/icons/arrow-back.svg';
import { ReactComponent as ArrowDownIcon } from 'ui/icons/arrow-down.svg';
import { ReactComponent as ArrowDownwardIcon } from 'ui/icons/arrow-downward.svg';
import { ReactComponent as ArrowDropDownIcon } from 'ui/icons/arrow-drop-down.svg';
import { ReactComponent as ArrowDropdownIcon } from 'ui/icons/arrow-dropdown.svg';
import { ReactComponent as ArrowForwardIcon } from 'ui/icons/arrow-forward.svg';
import { ReactComponent as ArrowIndentIcon } from 'ui/icons/arrow-indent.svg';
import { ReactComponent as ArrowLeftIcon } from 'ui/icons/arrow-left.svg';
import { ReactComponent as ArrowOrangeIcon } from 'ui/icons/arrow-orange.svg';
import { ReactComponent as ArrowRightIcon } from 'ui/icons/arrow-right.svg';
import { ReactComponent as ArrowUp2Icon } from 'ui/icons/arrow-up2.svg';
import { ReactComponent as Arrow1DownIcon } from 'ui/icons/arrow1-down.svg';
import { ReactComponent as Arrow1UpIcon } from 'ui/icons/arrow1-up.svg';
import { ReactComponent as Arrow2DownIcon } from 'ui/icons/arrow2-down.svg';
import { ReactComponent as Arrow2UpIcon } from 'ui/icons/arrow2-up.svg';
import { ReactComponent as ArtIcon } from 'ui/icons/art.svg';
import { ReactComponent as AstonishedIcon } from 'ui/icons/astonished.svg';
import { ReactComponent as AttachIcon } from 'ui/icons/attach.svg';
import { ReactComponent as AttachmentIcon } from 'ui/icons/attachment.svg';
import { ReactComponent as AudioIcon } from 'ui/icons/audio.svg';
import { ReactComponent as AutoSavedIcon } from 'ui/icons/auto-saved.svg';
import { ReactComponent as AwardIcon } from 'ui/icons/award.svg';
import { ReactComponent as BackupIcon } from 'ui/icons/backup.svg';
import { ReactComponent as BankIcon } from 'ui/icons/bank.svg';
import { ReactComponent as BarMenuAnalysisIcon } from 'ui/icons/bar-menu-analysis.svg';
import { ReactComponent as BarMenuContentIcon } from 'ui/icons/bar-menu-content.svg';
import { ReactComponent as BarMenuHomeIcon } from 'ui/icons/bar-menu-home.svg';
import { ReactComponent as BarMenuLicenseIcon } from 'ui/icons/bar-menu-license.svg';
import { ReactComponent as BarMenuSettingsIcon } from 'ui/icons/bar-menu-settings.svg';
import { ReactComponent as BarMenuUserIcon } from 'ui/icons/bar-menu-user.svg';
import { ReactComponent as BombIcon } from 'ui/icons/bomb.svg';
import { ReactComponent as BookIcon } from 'ui/icons/book.svg';
import { ReactComponent as BookLessonIcon } from 'ui/icons/book-lesson.svg';
import { ReactComponent as BookOpenIcon } from 'ui/icons/book-open.svg';
import { ReactComponent as BookSlashIcon } from 'ui/icons/book-slash.svg';
import { ReactComponent as BookmarkIcon } from 'ui/icons/bookmark.svg';
import { ReactComponent as BookmarksIcon } from 'ui/icons/bookmarks.svg';
import { ReactComponent as BooksIcon } from 'ui/icons/books.svg';
import { ReactComponent as BymeIcon } from 'ui/icons/byme.svg';
import { ReactComponent as CakeIcon } from 'ui/icons/cake.svg';
import { ReactComponent as CalcIcon } from 'ui/icons/calc.svg';
import { ReactComponent as CalendarIcon } from 'ui/icons/calendar.svg';
import { ReactComponent as CalendarDoneIcon } from 'ui/icons/calendar-done.svg';
import { ReactComponent as CameraIcon } from 'ui/icons/camera.svg';
import { ReactComponent as Carbon_TaskToolsIcon } from 'ui/icons/carbon_task-tools.svg';
import { ReactComponent as Caution_FillIcon } from 'ui/icons/caution_fill.svg';
import { ReactComponent as CautionFillSmIcon } from 'ui/icons/caution-fill-sm.svg';
import { ReactComponent as CautionOutlineIcon } from 'ui/icons/caution-outline.svg';
import { ReactComponent as Chat_BubbleIcon } from 'ui/icons/chat_bubble.svg';
import { ReactComponent as CheckIcon } from 'ui/icons/check.svg';
import { ReactComponent as CheckCheckedIcon } from 'ui/icons/check-checked.svg';
import { ReactComponent as CheckCheckedRoundIcon } from 'ui/icons/check-checked-round.svg';
import { ReactComponent as CheckCheckedRoundFillIcon } from 'ui/icons/check-checked-round-fill.svg';
import { ReactComponent as CheckCircleFillSmIcon } from 'ui/icons/check-circle-fill-sm.svg';
import { ReactComponent as CheckCircleOutlineIcon } from 'ui/icons/check-circle-outline.svg';
import { ReactComponent as CheckCurrentRoundIcon } from 'ui/icons/check-current-round.svg';
import { ReactComponent as CheckUncheckedIcon } from 'ui/icons/check-unchecked.svg';
import { ReactComponent as CheckUncheckedRoundIcon } from 'ui/icons/check-unchecked-round.svg';
import { ReactComponent as ChessIcon } from 'ui/icons/chess.svg';
import { ReactComponent as ChevronDownIcon } from 'ui/icons/chevron-down.svg';
import { ReactComponent as ChevronDownFillIcon } from 'ui/icons/chevron-down-fill.svg';
import { ReactComponent as ChevronLeftIcon } from 'ui/icons/chevron-left.svg';
import { ReactComponent as ChevronRightIcon } from 'ui/icons/chevron-right.svg';
import { ReactComponent as ChevronUpIcon } from 'ui/icons/chevron-up.svg';
import { ReactComponent as ChevronUpFilledIcon } from 'ui/icons/chevron-up-filled.svg';
import { ReactComponent as CircleIcon } from 'ui/icons/circle.svg';
import { ReactComponent as Circle_CheckIcon } from 'ui/icons/circle_check.svg';
import { ReactComponent as CircleCheckedIcon } from 'ui/icons/circle-checked.svg';
import { ReactComponent as CircleFilledIcon } from 'ui/icons/circle-filled.svg';
import { ReactComponent as CircleLessIcon } from 'ui/icons/circle-less.svg';
import { ReactComponent as ClassIcon } from 'ui/icons/class.svg';
import { ReactComponent as ClassArtIcon } from 'ui/icons/class-art.svg';
import { ReactComponent as ClassBookIcon } from 'ui/icons/class-book.svg';
import { ReactComponent as ClassChessIcon } from 'ui/icons/class-chess.svg';
import { ReactComponent as ClassGeographyIcon } from 'ui/icons/class-geography.svg';
import { ReactComponent as ClassHistoryIcon } from 'ui/icons/class-history.svg';
import { ReactComponent as ClassLanguageIcon } from 'ui/icons/class-language.svg';
import { ReactComponent as ClassMathsIcon } from 'ui/icons/class-maths.svg';
import { ReactComponent as ClassPresentationIcon } from 'ui/icons/class-presentation.svg';
import { ReactComponent as ClassScienceIcon } from 'ui/icons/class-science.svg';
import { ReactComponent as ClassSportIcon } from 'ui/icons/class-sport.svg';
import { ReactComponent as ClassTechnologyLanguageIcon } from 'ui/icons/class-technology-language.svg';
import { ReactComponent as ClassifyIcon } from 'ui/icons/classify.svg';
import { ReactComponent as ClassroomIcon } from 'ui/icons/classroom.svg';
import { ReactComponent as ClipboardIcon } from 'ui/icons/clipboard.svg';
import { ReactComponent as ClockIcon } from 'ui/icons/clock.svg';
import { ReactComponent as ClockColorIcon } from 'ui/icons/clock-color.svg';
import { ReactComponent as Clock2Icon } from 'ui/icons/clock2.svg';
import { ReactComponent as CloseIcon } from 'ui/icons/close.svg';
import { ReactComponent as Close2Icon } from 'ui/icons/close2.svg';
import { ReactComponent as CloudDoneIcon } from 'ui/icons/cloud-done.svg';
import { ReactComponent as CloudSavedIcon } from 'ui/icons/cloud-saved.svg';
import { ReactComponent as ClozeIcon } from 'ui/icons/cloze.svg';
import { ReactComponent as CommentIcon } from 'ui/icons/comment.svg';
import { ReactComponent as Comment_1Icon } from 'ui/icons/comment-1.svg';
import { ReactComponent as CommentFillIcon } from 'ui/icons/comment-fill.svg';
import { ReactComponent as CommentsIcon } from 'ui/icons/comments.svg';
import { ReactComponent as ConfigIcon } from 'ui/icons/config.svg';
import { ReactComponent as ContentIcon } from 'ui/icons/content.svg';
import { ReactComponent as ContentPasteIcon } from 'ui/icons/content-paste.svg';
import { ReactComponent as ConversationIcon } from 'ui/icons/conversation.svg';
import { ReactComponent as CopyIcon } from 'ui/icons/copy.svg';
import { ReactComponent as CopyBackofficeIcon } from 'ui/icons/copy-backoffice.svg';
import { ReactComponent as CropIcon } from 'ui/icons/crop.svg';
import { ReactComponent as CrossIcon } from 'ui/icons/cross.svg';
import { ReactComponent as CubeIcon } from 'ui/icons/cube.svg';
import { ReactComponent as DarkIcon } from 'ui/icons/dark.svg';
import { ReactComponent as DashboardIcon } from 'ui/icons/dashboard.svg';
import { ReactComponent as DateIcon } from 'ui/icons/date.svg';
import { ReactComponent as DeleteIcon } from 'ui/icons/delete.svg';
import { ReactComponent as DesktopIcon } from 'ui/icons/desktop.svg';
import { ReactComponent as Desktop2Icon } from 'ui/icons/desktop2.svg';
import { ReactComponent as DeviceIcon } from 'ui/icons/device.svg';
import { ReactComponent as DiagramIcon } from 'ui/icons/diagram.svg';
import { ReactComponent as DocIcon } from 'ui/icons/doc.svg';
import { ReactComponent as DoneIcon } from 'ui/icons/done.svg';
import { ReactComponent as DoneCircleIcon } from 'ui/icons/done-circle.svg';
import { ReactComponent as DownloadIcon } from 'ui/icons/download.svg';
import { ReactComponent as DownloadFilledIcon } from 'ui/icons/download-filled.svg';
import { ReactComponent as DragIcon } from 'ui/icons/drag.svg';
import { ReactComponent as DragBulletsIcon } from 'ui/icons/drag-bullets.svg';
import { ReactComponent as DriveIcon } from 'ui/icons/drive.svg';
import { ReactComponent as DriveDocIcon } from 'ui/icons/drive-doc.svg';
import { ReactComponent as DropdownDownIcon } from 'ui/icons/dropdown--down.svg';
import { ReactComponent as DropdownUpIcon } from 'ui/icons/dropdown--up.svg';
import { ReactComponent as DuplicateIcon } from 'ui/icons/duplicate.svg';
import { ReactComponent as EditIcon } from 'ui/icons/edit.svg';
import { ReactComponent as EditpostIcon } from 'ui/icons/editpost.svg';
import { ReactComponent as EdpuzzleIcon } from 'ui/icons/edpuzzle.svg';
import { ReactComponent as EdvDigitalIcon } from 'ui/icons/edv-digital.svg';
import { ReactComponent as EdvResourcesIcon } from 'ui/icons/edv-resources.svg';
import { ReactComponent as EmailIcon } from 'ui/icons/email.svg';
import { ReactComponent as EmailOutlinedIcon } from 'ui/icons/email-outlined.svg';
import { ReactComponent as EmojiAlertIcon } from 'ui/icons/emoji-alert.svg';
import { ReactComponent as EmojiAstonishedIcon } from 'ui/icons/emoji-astonished.svg';
import { ReactComponent as EmojiBombIcon } from 'ui/icons/emoji-bomb.svg';
import { ReactComponent as EmojiClockIcon } from 'ui/icons/emoji-clock.svg';
import { ReactComponent as EmojiCrossIcon } from 'ui/icons/emoji-cross.svg';
import { ReactComponent as EmojiDoneIcon } from 'ui/icons/emoji-done.svg';
import { ReactComponent as EmojiFaceWithSweatIcon } from 'ui/icons/emoji-face-with-sweat.svg';
import { ReactComponent as EmojiForbiddenIcon } from 'ui/icons/emoji-forbidden.svg';
import { ReactComponent as EmojiHaltIcon } from 'ui/icons/emoji-halt.svg';
import { ReactComponent as EmojiLightBulbIcon } from 'ui/icons/emoji-light-bulb.svg';
import { ReactComponent as EmojiMasterIcon } from 'ui/icons/emoji-master.svg';
import { ReactComponent as EmojiMedalIcon } from 'ui/icons/emoji-medal.svg';
import { ReactComponent as EmojiPanicIcon } from 'ui/icons/emoji-panic.svg';
import { ReactComponent as EmojiPartyIcon } from 'ui/icons/emoji-party.svg';
import { ReactComponent as EmojiRedFlagIcon } from 'ui/icons/emoji-red-flag.svg';
import { ReactComponent as EmojiSmillingIcon } from 'ui/icons/emoji-smilling.svg';
import { ReactComponent as EmojiStarIcon } from 'ui/icons/emoji-star.svg';
import { ReactComponent as EmojiStarsIcon } from 'ui/icons/emoji-stars.svg';
import { ReactComponent as EmojiStarsHoverIcon } from 'ui/icons/emoji-stars-hover.svg';
import { ReactComponent as EmojiStars2Icon } from 'ui/icons/emoji-stars2.svg';
import { ReactComponent as EmojiThumbsDownRedIcon } from 'ui/icons/emoji-thumbs-down-red.svg';
import { ReactComponent as EmojiThumbsUpIcon } from 'ui/icons/emoji-thumbs-up.svg';
import { ReactComponent as EmojiThumbsUpGreenIcon } from 'ui/icons/emoji-thumbs-up-green.svg';
import { ReactComponent as EmojiWarningIcon } from 'ui/icons/emoji-warning.svg';
import { ReactComponent as EmptyIcon } from 'ui/icons/empty.svg';
import { ReactComponent as EmptyFolderIcon } from 'ui/icons/empty-folder.svg';
import { ReactComponent as EmptyProgressIcon } from 'ui/icons/empty-progress.svg';
import { ReactComponent as EqualizerIcon } from 'ui/icons/equalizer.svg';
import { ReactComponent as EventIcon } from 'ui/icons/event.svg';
import { ReactComponent as ExamIcon } from 'ui/icons/exam.svg';
import { ReactComponent as ExclamationCircleIcon } from 'ui/icons/exclamation-circle.svg';
import { ReactComponent as ExclamationFilledIcon } from 'ui/icons/exclamation-filled.svg';
import { ReactComponent as ExerciseIcon } from 'ui/icons/exercise.svg';
import { ReactComponent as ExitIcon } from 'ui/icons/exit.svg';
import { ReactComponent as ExpandIcon } from 'ui/icons/expand.svg';
import { ReactComponent as ExploreIcon } from 'ui/icons/explore.svg';
import { ReactComponent as ExportIcon } from 'ui/icons/export.svg';
import { ReactComponent as ExternalLinkIcon } from 'ui/icons/external-link.svg';
import { ReactComponent as EyeIcon } from 'ui/icons/eye.svg';
import { ReactComponent as FaceWithSweatIcon } from 'ui/icons/face-with-sweat.svg';
import { ReactComponent as FavoriteIcon } from 'ui/icons/favorite.svg';
import { ReactComponent as FeedbackIcon } from 'ui/icons/feedback.svg';
import { ReactComponent as FileAudioIcon } from 'ui/icons/file-audio.svg';
import { ReactComponent as FileDocIcon } from 'ui/icons/file-doc.svg';
import { ReactComponent as FileDocumentIcon } from 'ui/icons/file-document.svg';
import { ReactComponent as FileImageIcon } from 'ui/icons/file-image.svg';
import { ReactComponent as FileLinkContentIcon } from 'ui/icons/file-link-content.svg';
import { ReactComponent as FilePdfIcon } from 'ui/icons/file-pdf.svg';
import { ReactComponent as FileTextIcon } from 'ui/icons/file-text.svg';
import { ReactComponent as FileTextFillIcon } from 'ui/icons/file-text-fill.svg';
import { ReactComponent as FileVideoIcon } from 'ui/icons/file-video.svg';
import { ReactComponent as FilterIcon } from 'ui/icons/filter.svg';
import { ReactComponent as FiltersIcon } from 'ui/icons/filters.svg';
import { ReactComponent as FireIcon } from 'ui/icons/fire.svg';
import { ReactComponent as FixedLayoutIcon } from 'ui/icons/fixed-layout.svg';
import { ReactComponent as FlagIcon } from 'ui/icons/flag.svg';
import { ReactComponent as FlameIcon } from 'ui/icons/flame.svg';
import { ReactComponent as FolderIcon } from 'ui/icons/folder.svg';
import { ReactComponent as FolderAddIcon } from 'ui/icons/folder-add.svg';
import { ReactComponent as FrameIcon } from 'ui/icons/frame.svg';
import { ReactComponent as FullscreenIcon } from 'ui/icons/fullscreen.svg';
import { ReactComponent as GalleryIcon } from 'ui/icons/gallery.svg';
import { ReactComponent as GeniallyIcon } from 'ui/icons/genially.svg';
import { ReactComponent as GeographyIcon } from 'ui/icons/geography.svg';
import { ReactComponent as GlobalEducaIcon } from 'ui/icons/global-educa.svg';
import { ReactComponent as GlobeShowingEuropeAfricaIcon } from 'ui/icons/globe-showing-europe-africa.svg';
import { ReactComponent as GlobeWithMeridiansIcon } from 'ui/icons/globe-with-meridians.svg';
import { ReactComponent as GoSteamIcon } from 'ui/icons/go-steam.svg';
import { ReactComponent as GoogleIcon } from 'ui/icons/google.svg';
import { ReactComponent as GoogleCalendarIcon } from 'ui/icons/google-calendar.svg';
import { ReactComponent as GoogleClassroomIcon } from 'ui/icons/google-classroom.svg';
import { ReactComponent as GoogleDriveIcon } from 'ui/icons/google-drive.svg';
import { ReactComponent as GradesIcon } from 'ui/icons/grades.svg';
import { ReactComponent as GradientStarIcon } from 'ui/icons/gradient-star.svg';
import { ReactComponent as GraphActivityIcon } from 'ui/icons/graph-activity.svg';
import { ReactComponent as GraphicIcon } from 'ui/icons/graphic.svg';
import { ReactComponent as GroupIcon } from 'ui/icons/group.svg';
import { ReactComponent as HaltIcon } from 'ui/icons/halt.svg';
import { ReactComponent as HandleIcon } from 'ui/icons/handle.svg';
import { ReactComponent as HeartIcon } from 'ui/icons/heart.svg';
import { ReactComponent as HeartFillIcon } from 'ui/icons/heart-fill.svg';
import { ReactComponent as HelpIcon } from 'ui/icons/help.svg';
import { ReactComponent as HideIcon } from 'ui/icons/hide.svg';
import { ReactComponent as HintIcon } from 'ui/icons/hint.svg';
import { ReactComponent as HistoryIcon } from 'ui/icons/history.svg';
import { ReactComponent as HomeIcon } from 'ui/icons/home.svg';
import { ReactComponent as HomeworkIcon } from 'ui/icons/homework.svg';
import { ReactComponent as HrIcon } from 'ui/icons/hr.svg';
import { ReactComponent as Ic_Person_24pxIcon } from 'ui/icons/ic_person_24px.svg';
import { ReactComponent as IconHomeLinkIcon } from 'ui/icons/icon-home-link.svg';
import { ReactComponent as IconPlusIcon } from 'ui/icons/icon-plus.svg';
import { ReactComponent as ImageIcon } from 'ui/icons/image.svg';
import { ReactComponent as ImageFillIcon } from 'ui/icons/image-fill.svg';
import { ReactComponent as InboxIcon } from 'ui/icons/inbox.svg';
import { ReactComponent as IncorrectCircleIcon } from 'ui/icons/incorrect-circle.svg';
import { ReactComponent as Info_CircleIcon } from 'ui/icons/info_circle.svg';
import { ReactComponent as InfoCircleIcon } from 'ui/icons/info-circle.svg';
import { ReactComponent as InfoCircleFillIcon } from 'ui/icons/info-circle-fill.svg';
import { ReactComponent as KanbanIcon } from 'ui/icons/kanban.svg';
import { ReactComponent as Kanban2Icon } from 'ui/icons/kanban2.svg';
import { ReactComponent as KeyIcon } from 'ui/icons/key.svg';
import { ReactComponent as KeyFilledIcon } from 'ui/icons/key-filled.svg';
import { ReactComponent as LabelIcon } from 'ui/icons/label.svg';
import { ReactComponent as LanguageIcon } from 'ui/icons/language.svg';
import { ReactComponent as LateiconIcon } from 'ui/icons/lateicon.svg';
import { ReactComponent as LessonIcon } from 'ui/icons/lesson.svg';
import { ReactComponent as LessonBackofficeIcon } from 'ui/icons/lesson-backoffice.svg';
import { ReactComponent as LessonTeacherIcon } from 'ui/icons/lesson-teacher.svg';
import { ReactComponent as LibraryIcon } from 'ui/icons/library.svg';
import { ReactComponent as LightIcon } from 'ui/icons/light.svg';
import { ReactComponent as Light_BulbIcon } from 'ui/icons/light_bulb.svg';
import { ReactComponent as LightBulbIcon } from 'ui/icons/light-bulb.svg';
import { ReactComponent as LightningIcon } from 'ui/icons/lightning.svg';
import { ReactComponent as LightningOffIcon } from 'ui/icons/lightning-off.svg';
import { ReactComponent as LightningOutlinedIcon } from 'ui/icons/lightning-outlined.svg';
import { ReactComponent as LikeIcon } from 'ui/icons/like.svg';
import { ReactComponent as LinkIcon } from 'ui/icons/link.svg';
import { ReactComponent as Link_NewIcon } from 'ui/icons/link_new.svg';
import { ReactComponent as LinkContentIcon } from 'ui/icons/link-content.svg';
import { ReactComponent as LinuxIcon } from 'ui/icons/linux.svg';
import { ReactComponent as ListIcon } from 'ui/icons/list.svg';
import { ReactComponent as LoadingIcon } from 'ui/icons/loading.svg';
import { ReactComponent as LockIcon } from 'ui/icons/lock.svg';
import { ReactComponent as Lock2Icon } from 'ui/icons/lock2.svg';
import { ReactComponent as MImageIcon } from 'ui/icons/m-image.svg';
import { ReactComponent as MSlideIcon } from 'ui/icons/m-slide.svg';
import { ReactComponent as MVideoIcon } from 'ui/icons/m-video.svg';
import { ReactComponent as MacIcon } from 'ui/icons/mac.svg';
import { ReactComponent as MagicWandIcon } from 'ui/icons/magic-wand.svg';
import { ReactComponent as MagicWandColorIcon } from 'ui/icons/magic-wand-color.svg';
import { ReactComponent as MapIcon } from 'ui/icons/map.svg';
import { ReactComponent as MapPinIcon } from 'ui/icons/map-pin.svg';
import { ReactComponent as MasterIcon } from 'ui/icons/master.svg';
import { ReactComponent as MathIcon } from 'ui/icons/math.svg';
import { ReactComponent as MathsIcon } from 'ui/icons/maths.svg';
import { ReactComponent as MatificIcon } from 'ui/icons/matific.svg';
import { ReactComponent as MaximizeIcon } from 'ui/icons/maximize.svg';
import { ReactComponent as MedalIcon } from 'ui/icons/medal.svg';
import { ReactComponent as MegaphoneIcon } from 'ui/icons/megaphone.svg';
import { ReactComponent as MegaphoneColorIcon } from 'ui/icons/megaphone-color.svg';
import { ReactComponent as MemoIcon } from 'ui/icons/memo.svg';
import { ReactComponent as MenuIcon } from 'ui/icons/menu.svg';
import { ReactComponent as MessageCircleIcon } from 'ui/icons/message-circle.svg';
import { ReactComponent as MicIcon } from 'ui/icons/mic.svg';
import { ReactComponent as MicrophoneIcon } from 'ui/icons/microphone.svg';
import { ReactComponent as MicrosoftIcon } from 'ui/icons/microsoft.svg';
import { ReactComponent as MinigameIcon } from 'ui/icons/minigame.svg';
import { ReactComponent as MinimizeIcon } from 'ui/icons/minimize.svg';
import { ReactComponent as MintIcon } from 'ui/icons/mint.svg';
import { ReactComponent as MintPostIcon } from 'ui/icons/mint-post.svg';
import { ReactComponent as MinusIcon } from 'ui/icons/minus.svg';
import { ReactComponent as MinusCircleIcon } from 'ui/icons/minus-circle.svg';
import { ReactComponent as MonitorIcon } from 'ui/icons/monitor.svg';
import { ReactComponent as MoreIcon } from 'ui/icons/more.svg';
import { ReactComponent as MoreBulletsIcon } from 'ui/icons/more-bullets.svg';
import { ReactComponent as MoreBulletsVerticalIcon } from 'ui/icons/more-bullets-vertical.svg';
import { ReactComponent as MoveIcon } from 'ui/icons/move.svg';
import { ReactComponent as MoveDownIcon } from 'ui/icons/move-down.svg';
import { ReactComponent as MoveUpIcon } from 'ui/icons/move-up.svg';
import { ReactComponent as MsteamsIcon } from 'ui/icons/msteams.svg';
import { ReactComponent as MultipleIcon } from 'ui/icons/multiple.svg';
import { ReactComponent as NewIcon } from 'ui/icons/new.svg';
import { ReactComponent as NewSquareIcon } from 'ui/icons/new-square.svg';
import { ReactComponent as NotebookIcon } from 'ui/icons/notebook.svg';
import { ReactComponent as NotificationsIcon } from 'ui/icons/notifications.svg';
import { ReactComponent as OffIcon } from 'ui/icons/off.svg';
import { ReactComponent as OffSessionIcon } from 'ui/icons/off-session.svg';
import { ReactComponent as OneDriveIcon } from 'ui/icons/one-drive.svg';
import { ReactComponent as OnlineIcon } from 'ui/icons/online.svg';
import { ReactComponent as OnsiteIcon } from 'ui/icons/onsite.svg';
import { ReactComponent as OtherIcon } from 'ui/icons/other.svg';
import { ReactComponent as PaletteIcon } from 'ui/icons/palette.svg';
import { ReactComponent as PanoramaIcon } from 'ui/icons/panorama.svg';
import { ReactComponent as PantoneIcon } from 'ui/icons/pantone.svg';
import { ReactComponent as PartyIcon } from 'ui/icons/party.svg';
import { ReactComponent as PartyPopperIcon } from 'ui/icons/party-popper.svg';
import { ReactComponent as PasswordIcon } from 'ui/icons/password.svg';
import { ReactComponent as PauseIcon } from 'ui/icons/pause.svg';
import { ReactComponent as PauseCircleIcon } from 'ui/icons/pause-circle.svg';
import { ReactComponent as PdfIcon } from 'ui/icons/pdf.svg';
import { ReactComponent as Pdf2Icon } from 'ui/icons/pdf2.svg';
import { ReactComponent as PencilIcon } from 'ui/icons/pencil.svg';
import { ReactComponent as PencilColorIcon } from 'ui/icons/pencil-color.svg';
import { ReactComponent as PhotoIcon } from 'ui/icons/photo.svg';
import { ReactComponent as PinIcon } from 'ui/icons/pin.svg';
import { ReactComponent as PinLocationIcon } from 'ui/icons/pin-location.svg';
import { ReactComponent as PinnedIcon } from 'ui/icons/pinned.svg';
import { ReactComponent as PlanetIcon } from 'ui/icons/planet.svg';
import { ReactComponent as PlayIcon } from 'ui/icons/play.svg';
import { ReactComponent as PlayArrowIcon } from 'ui/icons/play-arrow.svg';
import { ReactComponent as PlayCircleIcon } from 'ui/icons/play-circle.svg';
import { ReactComponent as PlayCircleFillIcon } from 'ui/icons/play-circle-fill.svg';
import { ReactComponent as PlaySimpleIcon } from 'ui/icons/play-simple.svg';
import { ReactComponent as PlenoIcon } from 'ui/icons/pleno.svg';
import { ReactComponent as PlenoWhiteIcon } from 'ui/icons/pleno-white.svg';
import { ReactComponent as PlusIcon } from 'ui/icons/plus.svg';
import { ReactComponent as Plus_CircleIcon } from 'ui/icons/plus_circle.svg';
import { ReactComponent as PollIcon } from 'ui/icons/poll.svg';
import { ReactComponent as Poll_1Icon } from 'ui/icons/poll-1.svg';
import { ReactComponent as PolpIcon } from 'ui/icons/polp.svg';
import { ReactComponent as PopupCloseIcon } from 'ui/icons/popup-close.svg';
import { ReactComponent as PresentationIcon } from 'ui/icons/presentation.svg';
import { ReactComponent as PrimaryLabelIcon } from 'ui/icons/primary-label.svg';
import { ReactComponent as PrimaryLabel_1Icon } from 'ui/icons/primary-label-1.svg';
import { ReactComponent as PrimaryLabel_2Icon } from 'ui/icons/primary-label-2.svg';
import { ReactComponent as PrimaryLabel_3Icon } from 'ui/icons/primary-label-3.svg';
import { ReactComponent as PrintIcon } from 'ui/icons/print.svg';
import { ReactComponent as ProfileIcon } from 'ui/icons/profile.svg';
import { ReactComponent as ProgramIcon } from 'ui/icons/program.svg';
import { ReactComponent as Project3Icon } from 'ui/icons/project3.svg';
import { ReactComponent as PublishIcon } from 'ui/icons/publish.svg';
import { ReactComponent as QuestionaryIcon } from 'ui/icons/questionary.svg';
import { ReactComponent as QuestionmarkIcon } from 'ui/icons/questionmark.svg';
import { ReactComponent as RadarIcon } from 'ui/icons/radar.svg';
import { ReactComponent as RandomIcon } from 'ui/icons/random.svg';
import { ReactComponent as RayoIcon } from 'ui/icons/rayo.svg';
import { ReactComponent as RedflagIcon } from 'ui/icons/redflag.svg';
import { ReactComponent as RefreshIcon } from 'ui/icons/refresh.svg';
import { ReactComponent as RenameIcon } from 'ui/icons/rename.svg';
import { ReactComponent as ReplayIcon } from 'ui/icons/replay.svg';
import { ReactComponent as ReplayHistoryIcon } from 'ui/icons/replay-history.svg';
import { ReactComponent as ReportIcon } from 'ui/icons/report.svg';
import { ReactComponent as RestoreIcon } from 'ui/icons/restore.svg';
import { ReactComponent as ReturnIcon } from 'ui/icons/return.svg';
import { ReactComponent as SProfileIcon } from 'ui/icons/s-profile.svg';
import { ReactComponent as SchemeIcon } from 'ui/icons/scheme.svg';
import { ReactComponent as SchoolIcon } from 'ui/icons/school.svg';
import { ReactComponent as ScienceIcon } from 'ui/icons/science.svg';
import { ReactComponent as SearchIcon } from 'ui/icons/search.svg';
import { ReactComponent as SendIcon } from 'ui/icons/send.svg';
import { ReactComponent as SettingIcon } from 'ui/icons/setting.svg';
import { ReactComponent as SettingsIcon } from 'ui/icons/settings.svg';
import { ReactComponent as SettingsFillIcon } from 'ui/icons/settings-fill.svg';
import { ReactComponent as ShareIcon } from 'ui/icons/share.svg';
import { ReactComponent as Share_2Icon } from 'ui/icons/share-2.svg';
import { ReactComponent as SmartphoneIcon } from 'ui/icons/smartphone.svg';
import { ReactComponent as Smile_01Icon } from 'ui/icons/smile-01.svg';
import { ReactComponent as Smile_02Icon } from 'ui/icons/smile-02.svg';
import { ReactComponent as Smile_03Icon } from 'ui/icons/smile-03.svg';
import { ReactComponent as SmilingIcon } from 'ui/icons/smiling.svg';
import { ReactComponent as SortAscendingIcon } from 'ui/icons/sort-ascending.svg';
import { ReactComponent as SortDescendingIcon } from 'ui/icons/sort-descending.svg';
import { ReactComponent as SparklesIcon } from 'ui/icons/sparkles.svg';
import { ReactComponent as SportIcon } from 'ui/icons/sport.svg';
import { ReactComponent as SquareCheckedIcon } from 'ui/icons/square-checked.svg';
import { ReactComponent as SquareUncheckedIcon } from 'ui/icons/square-unchecked.svg';
import { ReactComponent as StarIcon } from 'ui/icons/star.svg';
import { ReactComponent as StarEvaluableIcon } from 'ui/icons/star-evaluable.svg';
import { ReactComponent as StarFillIcon } from 'ui/icons/star-fill.svg';
import { ReactComponent as StarFullIcon } from 'ui/icons/star-full.svg';
import { ReactComponent as StarHalfIcon } from 'ui/icons/star-half.svg';
import { ReactComponent as StarLineIcon } from 'ui/icons/star-line.svg';
import { ReactComponent as StarOutlinedIcon } from 'ui/icons/star-outlined.svg';
import { ReactComponent as StarRoundIcon } from 'ui/icons/star-round.svg';
import { ReactComponent as StarsIcon } from 'ui/icons/stars.svg';
import { ReactComponent as Stars2Icon } from 'ui/icons/stars2.svg';
import { ReactComponent as Status_Error_FillIcon } from 'ui/icons/status_error_fill.svg';
import { ReactComponent as Status_Info_FillIcon } from 'ui/icons/status_info_fill.svg';
import { ReactComponent as Status_Success_FillIcon } from 'ui/icons/status_success_fill.svg';
import { ReactComponent as Status_Warning_FillIcon } from 'ui/icons/status_warning_fill.svg';
import { ReactComponent as StopIcon } from 'ui/icons/stop.svg';
import { ReactComponent as StreamIcon } from 'ui/icons/stream.svg';
import { ReactComponent as StudentIcon } from 'ui/icons/student.svg';
import { ReactComponent as StudentsIcon } from 'ui/icons/students.svg';
import { ReactComponent as SuccessIcon } from 'ui/icons/success.svg';
import { ReactComponent as SustoIcon } from 'ui/icons/susto.svg';
import { ReactComponent as SwitchOffIcon } from 'ui/icons/switch-off.svg';
import { ReactComponent as SwitchOnIcon } from 'ui/icons/switch-on.svg';
import { ReactComponent as TabletIcon } from 'ui/icons/tablet.svg';
import { ReactComponent as TaskIcon } from 'ui/icons/task.svg';
import { ReactComponent as Task2Icon } from 'ui/icons/task2.svg';
import { ReactComponent as TatumIcon } from 'ui/icons/tatum.svg';
import { ReactComponent as TeacherIcon } from 'ui/icons/teacher.svg';
import { ReactComponent as TeamsIcon } from 'ui/icons/teams.svg';
import { ReactComponent as TechnologyLanguageIcon } from 'ui/icons/technology-language.svg';
import { ReactComponent as TestIcon } from 'ui/icons/test.svg';
import { ReactComponent as TestgroupIcon } from 'ui/icons/testgroup.svg';
import { ReactComponent as TextIcon } from 'ui/icons/text.svg';
import { ReactComponent as Thumb_UpIcon } from 'ui/icons/thumb_up.svg';
import { ReactComponent as ThumbsDownRedIcon } from 'ui/icons/thumbs-down-red.svg';
import { ReactComponent as ThumbsUpIcon } from 'ui/icons/thumbs-up.svg';
import { ReactComponent as ThumbsUpGreenIcon } from 'ui/icons/thumbs-up-green.svg';
import { ReactComponent as ThumbsdownIcon } from 'ui/icons/thumbsdown.svg';
import { ReactComponent as Thumbsdown_FillIcon } from 'ui/icons/thumbsdown_fill.svg';
import { ReactComponent as ThumbsupIcon } from 'ui/icons/thumbsup.svg';
import { ReactComponent as Thumbsup_FillIcon } from 'ui/icons/thumbsup_fill.svg';
import { ReactComponent as TimelapseIcon } from 'ui/icons/timelapse.svg';
import { ReactComponent as TimerIcon } from 'ui/icons/timer.svg';
import { ReactComponent as ToDoIcon } from 'ui/icons/to-do.svg';
import { ReactComponent as ToggleActiveIcon } from 'ui/icons/toggle--active.svg';
import { ReactComponent as ToggleDisabledIcon } from 'ui/icons/toggle--disabled.svg';
import { ReactComponent as ToggleOffIcon } from 'ui/icons/toggle-off.svg';
import { ReactComponent as ToggleOnIcon } from 'ui/icons/toggle-on.svg';
import { ReactComponent as ToolGeneratorIcon } from 'ui/icons/tool-generator.svg';
import { ReactComponent as ToolsIcon } from 'ui/icons/tools.svg';
import { ReactComponent as TrashIcon } from 'ui/icons/trash.svg';
import { ReactComponent as Trash_2Icon } from 'ui/icons/trash-2.svg';
import { ReactComponent as TrendDownIcon } from 'ui/icons/trend-down.svg';
import { ReactComponent as TrendUpIcon } from 'ui/icons/trend-up.svg';
import { ReactComponent as TypingIcon } from 'ui/icons/typing.svg';
import { ReactComponent as UploadIcon } from 'ui/icons/upload.svg';
import { ReactComponent as UploadFileIcon } from 'ui/icons/upload-file.svg';
import { ReactComponent as UploadImageIcon } from 'ui/icons/upload-image.svg';
import { ReactComponent as UploadLineIcon } from 'ui/icons/upload-line.svg';
import { ReactComponent as UserIcon } from 'ui/icons/user.svg';
import { ReactComponent as UserFilledIcon } from 'ui/icons/user-filled.svg';
import { ReactComponent as User2Icon } from 'ui/icons/user2.svg';
import { ReactComponent as UsereditIcon } from 'ui/icons/useredit.svg';
import { ReactComponent as Version_HistoryIcon } from 'ui/icons/version_history.svg';
import { ReactComponent as VideoIcon } from 'ui/icons/video.svg';
import { ReactComponent as VideoCameraIcon } from 'ui/icons/video-camera.svg';
import { ReactComponent as VideoMovieIcon } from 'ui/icons/video-movie.svg';
import { ReactComponent as VideocameraIcon } from 'ui/icons/videocamera.svg';
import { ReactComponent as VideolessonIcon } from 'ui/icons/videolesson.svg';
import { ReactComponent as ViewsIcon } from 'ui/icons/views.svg';
import { ReactComponent as VisibilityIcon } from 'ui/icons/visibility.svg';
import { ReactComponent as Visibility_OffIcon } from 'ui/icons/visibility_off.svg';
import { ReactComponent as VisibleIcon } from 'ui/icons/visible.svg';
import { ReactComponent as VisibleOffIcon } from 'ui/icons/visible-off.svg';
import { ReactComponent as VolumeOffIcon } from 'ui/icons/volume-off.svg';
import { ReactComponent as VolumeUpIcon } from 'ui/icons/volume-up.svg';
import { ReactComponent as WarningIcon } from 'ui/icons/warning.svg';
import { ReactComponent as WarningCircleIcon } from 'ui/icons/warning-circle.svg';
import { ReactComponent as WarningCircleFillIcon } from 'ui/icons/warning-circle-fill.svg';
import { ReactComponent as WeblinkIcon } from 'ui/icons/weblink.svg';
import { ReactComponent as WifiIcon } from 'ui/icons/wifi.svg';
import { ReactComponent as WindowsIcon } from 'ui/icons/windows.svg';
import { ReactComponent as Wordpress_MediaIcon } from 'ui/icons/wordpress_media.svg';
import { ReactComponent as WorldIcon } from 'ui/icons/world.svg';
import { ReactComponent as XapiIcon } from 'ui/icons/xapi.svg';
import { ReactComponent as ZipIcon } from 'ui/icons/zip.svg';
import { ReactComponent as ZoomInIcon } from 'ui/icons/zoom-in.svg';
import { ReactComponent as ZoomOutIcon } from 'ui/icons/zoom-out.svg';

export type IconRegistryEntry = {
  Component: FC<SVGProps<SVGSVGElement>>;
  preservesFills: boolean;
};

export const ICONS = {
  'add': { Component: AddIcon, preservesFills: false },
  'add-circle': { Component: AddCircleIcon, preservesFills: false },
  'add-circle-filled': { Component: AddCircleFilledIcon, preservesFills: false },
  'add-class': { Component: AddClassIcon, preservesFills: false },
  'add-img': { Component: AddImgIcon, preservesFills: true },
  'ai': { Component: AiIcon, preservesFills: false },
  'ai-generate': { Component: AiGenerateIcon, preservesFills: false },
  'airplay': { Component: AirplayIcon, preservesFills: false },
  'alarm': { Component: AlarmIcon, preservesFills: false },
  'alarm-off': { Component: AlarmOffIcon, preservesFills: false },
  'alert': { Component: AlertIcon, preservesFills: false },
  'all-class': { Component: AllClassIcon, preservesFills: false },
  'apps': { Component: AppsIcon, preservesFills: false },
  'archive': { Component: ArchiveIcon, preservesFills: false },
  'archive2': { Component: Archive2Icon, preservesFills: false },
  'arroba': { Component: ArrobaIcon, preservesFills: false },
  'arrow_forward': { Component: Arrow_ForwardIcon, preservesFills: false },
  'arrow-back': { Component: ArrowBackIcon, preservesFills: false },
  'arrow-down': { Component: ArrowDownIcon, preservesFills: false },
  'arrow-downward': { Component: ArrowDownwardIcon, preservesFills: false },
  'arrow-drop-down': { Component: ArrowDropDownIcon, preservesFills: false },
  'arrow-dropdown': { Component: ArrowDropdownIcon, preservesFills: false },
  'arrow-forward': { Component: ArrowForwardIcon, preservesFills: false },
  'arrow-indent': { Component: ArrowIndentIcon, preservesFills: false },
  'arrow-left': { Component: ArrowLeftIcon, preservesFills: false },
  'arrow-orange': { Component: ArrowOrangeIcon, preservesFills: false },
  'arrow-right': { Component: ArrowRightIcon, preservesFills: false },
  'arrow-up2': { Component: ArrowUp2Icon, preservesFills: false },
  'arrow1-down': { Component: Arrow1DownIcon, preservesFills: false },
  'arrow1-up': { Component: Arrow1UpIcon, preservesFills: false },
  'arrow2-down': { Component: Arrow2DownIcon, preservesFills: false },
  'arrow2-up': { Component: Arrow2UpIcon, preservesFills: false },
  'art': { Component: ArtIcon, preservesFills: false },
  'astonished': { Component: AstonishedIcon, preservesFills: true },
  'attach': { Component: AttachIcon, preservesFills: false },
  'attachment': { Component: AttachmentIcon, preservesFills: false },
  'audio': { Component: AudioIcon, preservesFills: false },
  'auto-saved': { Component: AutoSavedIcon, preservesFills: false },
  'award': { Component: AwardIcon, preservesFills: false },
  'backup': { Component: BackupIcon, preservesFills: false },
  'bank': { Component: BankIcon, preservesFills: false },
  'bar-menu-analysis': { Component: BarMenuAnalysisIcon, preservesFills: false },
  'bar-menu-content': { Component: BarMenuContentIcon, preservesFills: false },
  'bar-menu-home': { Component: BarMenuHomeIcon, preservesFills: false },
  'bar-menu-license': { Component: BarMenuLicenseIcon, preservesFills: false },
  'bar-menu-settings': { Component: BarMenuSettingsIcon, preservesFills: false },
  'bar-menu-user': { Component: BarMenuUserIcon, preservesFills: false },
  'bomb': { Component: BombIcon, preservesFills: true },
  'book': { Component: BookIcon, preservesFills: false },
  'book-lesson': { Component: BookLessonIcon, preservesFills: true },
  'book-open': { Component: BookOpenIcon, preservesFills: false },
  'book-slash': { Component: BookSlashIcon, preservesFills: false },
  'bookmark': { Component: BookmarkIcon, preservesFills: false },
  'bookmarks': { Component: BookmarksIcon, preservesFills: false },
  'books': { Component: BooksIcon, preservesFills: true },
  'byme': { Component: BymeIcon, preservesFills: true },
  'cake': { Component: CakeIcon, preservesFills: false },
  'calc': { Component: CalcIcon, preservesFills: false },
  'calendar': { Component: CalendarIcon, preservesFills: false },
  'calendar-done': { Component: CalendarDoneIcon, preservesFills: false },
  'camera': { Component: CameraIcon, preservesFills: false },
  'carbon_task-tools': { Component: Carbon_TaskToolsIcon, preservesFills: false },
  'caution_fill': { Component: Caution_FillIcon, preservesFills: false },
  'caution-fill-sm': { Component: CautionFillSmIcon, preservesFills: false },
  'caution-outline': { Component: CautionOutlineIcon, preservesFills: false },
  'chat_bubble': { Component: Chat_BubbleIcon, preservesFills: false },
  'check': { Component: CheckIcon, preservesFills: false },
  'check-checked': { Component: CheckCheckedIcon, preservesFills: false },
  'check-checked-round': { Component: CheckCheckedRoundIcon, preservesFills: false },
  'check-checked-round-fill': { Component: CheckCheckedRoundFillIcon, preservesFills: false },
  'check-circle-fill-sm': { Component: CheckCircleFillSmIcon, preservesFills: false },
  'check-circle-outline': { Component: CheckCircleOutlineIcon, preservesFills: false },
  'check-current-round': { Component: CheckCurrentRoundIcon, preservesFills: false },
  'check-unchecked': { Component: CheckUncheckedIcon, preservesFills: false },
  'check-unchecked-round': { Component: CheckUncheckedRoundIcon, preservesFills: false },
  'chess': { Component: ChessIcon, preservesFills: false },
  'chevron-down': { Component: ChevronDownIcon, preservesFills: false },
  'chevron-down-fill': { Component: ChevronDownFillIcon, preservesFills: false },
  'chevron-left': { Component: ChevronLeftIcon, preservesFills: false },
  'chevron-right': { Component: ChevronRightIcon, preservesFills: false },
  'chevron-up': { Component: ChevronUpIcon, preservesFills: false },
  'chevron-up-filled': { Component: ChevronUpFilledIcon, preservesFills: false },
  'circle': { Component: CircleIcon, preservesFills: false },
  'circle_check': { Component: Circle_CheckIcon, preservesFills: false },
  'circle-checked': { Component: CircleCheckedIcon, preservesFills: false },
  'circle-filled': { Component: CircleFilledIcon, preservesFills: true },
  'circle-less': { Component: CircleLessIcon, preservesFills: false },
  'class': { Component: ClassIcon, preservesFills: false },
  'class-art': { Component: ClassArtIcon, preservesFills: false },
  'class-book': { Component: ClassBookIcon, preservesFills: false },
  'class-chess': { Component: ClassChessIcon, preservesFills: false },
  'class-geography': { Component: ClassGeographyIcon, preservesFills: false },
  'class-history': { Component: ClassHistoryIcon, preservesFills: false },
  'class-language': { Component: ClassLanguageIcon, preservesFills: false },
  'class-maths': { Component: ClassMathsIcon, preservesFills: false },
  'class-presentation': { Component: ClassPresentationIcon, preservesFills: false },
  'class-science': { Component: ClassScienceIcon, preservesFills: false },
  'class-sport': { Component: ClassSportIcon, preservesFills: false },
  'class-technology-language': { Component: ClassTechnologyLanguageIcon, preservesFills: false },
  'classify': { Component: ClassifyIcon, preservesFills: false },
  'classroom': { Component: ClassroomIcon, preservesFills: true },
  'clipboard': { Component: ClipboardIcon, preservesFills: false },
  'clock': { Component: ClockIcon, preservesFills: false },
  'clock-color': { Component: ClockColorIcon, preservesFills: true },
  'clock2': { Component: Clock2Icon, preservesFills: false },
  'close': { Component: CloseIcon, preservesFills: false },
  'close2': { Component: Close2Icon, preservesFills: false },
  'cloud-done': { Component: CloudDoneIcon, preservesFills: false },
  'cloud-saved': { Component: CloudSavedIcon, preservesFills: false },
  'cloze': { Component: ClozeIcon, preservesFills: false },
  'comment': { Component: CommentIcon, preservesFills: false },
  'comment-1': { Component: Comment_1Icon, preservesFills: false },
  'comment-fill': { Component: CommentFillIcon, preservesFills: false },
  'comments': { Component: CommentsIcon, preservesFills: false },
  'config': { Component: ConfigIcon, preservesFills: false },
  'content': { Component: ContentIcon, preservesFills: false },
  'content-paste': { Component: ContentPasteIcon, preservesFills: false },
  'conversation': { Component: ConversationIcon, preservesFills: false },
  'copy': { Component: CopyIcon, preservesFills: false },
  'copy-backoffice': { Component: CopyBackofficeIcon, preservesFills: false },
  'crop': { Component: CropIcon, preservesFills: false },
  'cross': { Component: CrossIcon, preservesFills: false },
  'cube': { Component: CubeIcon, preservesFills: false },
  'dark': { Component: DarkIcon, preservesFills: false },
  'dashboard': { Component: DashboardIcon, preservesFills: true },
  'date': { Component: DateIcon, preservesFills: false },
  'delete': { Component: DeleteIcon, preservesFills: false },
  'desktop': { Component: DesktopIcon, preservesFills: false },
  'desktop2': { Component: Desktop2Icon, preservesFills: false },
  'device': { Component: DeviceIcon, preservesFills: false },
  'diagram': { Component: DiagramIcon, preservesFills: false },
  'doc': { Component: DocIcon, preservesFills: false },
  'done': { Component: DoneIcon, preservesFills: false },
  'done-circle': { Component: DoneCircleIcon, preservesFills: true },
  'download': { Component: DownloadIcon, preservesFills: false },
  'download-filled': { Component: DownloadFilledIcon, preservesFills: false },
  'drag': { Component: DragIcon, preservesFills: false },
  'drag-bullets': { Component: DragBulletsIcon, preservesFills: false },
  'drive': { Component: DriveIcon, preservesFills: false },
  'drive-doc': { Component: DriveDocIcon, preservesFills: false },
  'dropdown--down': { Component: DropdownDownIcon, preservesFills: false },
  'dropdown--up': { Component: DropdownUpIcon, preservesFills: false },
  'duplicate': { Component: DuplicateIcon, preservesFills: false },
  'edit': { Component: EditIcon, preservesFills: false },
  'editpost': { Component: EditpostIcon, preservesFills: false },
  'edpuzzle': { Component: EdpuzzleIcon, preservesFills: false },
  'edv-digital': { Component: EdvDigitalIcon, preservesFills: false },
  'edv-resources': { Component: EdvResourcesIcon, preservesFills: false },
  'email': { Component: EmailIcon, preservesFills: false },
  'email-outlined': { Component: EmailOutlinedIcon, preservesFills: false },
  'emoji-alert': { Component: EmojiAlertIcon, preservesFills: true },
  'emoji-astonished': { Component: EmojiAstonishedIcon, preservesFills: true },
  'emoji-bomb': { Component: EmojiBombIcon, preservesFills: true },
  'emoji-clock': { Component: EmojiClockIcon, preservesFills: true },
  'emoji-cross': { Component: EmojiCrossIcon, preservesFills: false },
  'emoji-done': { Component: EmojiDoneIcon, preservesFills: false },
  'emoji-face-with-sweat': { Component: EmojiFaceWithSweatIcon, preservesFills: true },
  'emoji-forbidden': { Component: EmojiForbiddenIcon, preservesFills: true },
  'emoji-halt': { Component: EmojiHaltIcon, preservesFills: true },
  'emoji-light-bulb': { Component: EmojiLightBulbIcon, preservesFills: true },
  'emoji-master': { Component: EmojiMasterIcon, preservesFills: true },
  'emoji-medal': { Component: EmojiMedalIcon, preservesFills: true },
  'emoji-panic': { Component: EmojiPanicIcon, preservesFills: true },
  'emoji-party': { Component: EmojiPartyIcon, preservesFills: true },
  'emoji-red-flag': { Component: EmojiRedFlagIcon, preservesFills: true },
  'emoji-smilling': { Component: EmojiSmillingIcon, preservesFills: true },
  'emoji-star': { Component: EmojiStarIcon, preservesFills: true },
  'emoji-stars': { Component: EmojiStarsIcon, preservesFills: true },
  'emoji-stars-hover': { Component: EmojiStarsHoverIcon, preservesFills: true },
  'emoji-stars2': { Component: EmojiStars2Icon, preservesFills: true },
  'emoji-thumbs-down-red': { Component: EmojiThumbsDownRedIcon, preservesFills: true },
  'emoji-thumbs-up': { Component: EmojiThumbsUpIcon, preservesFills: true },
  'emoji-thumbs-up-green': { Component: EmojiThumbsUpGreenIcon, preservesFills: true },
  'emoji-warning': { Component: EmojiWarningIcon, preservesFills: true },
  'empty': { Component: EmptyIcon, preservesFills: false },
  'empty-folder': { Component: EmptyFolderIcon, preservesFills: false },
  'empty-progress': { Component: EmptyProgressIcon, preservesFills: false },
  'equalizer': { Component: EqualizerIcon, preservesFills: false },
  'event': { Component: EventIcon, preservesFills: false },
  'exam': { Component: ExamIcon, preservesFills: false },
  'exclamation-circle': { Component: ExclamationCircleIcon, preservesFills: true },
  'exclamation-filled': { Component: ExclamationFilledIcon, preservesFills: false },
  'exercise': { Component: ExerciseIcon, preservesFills: false },
  'exit': { Component: ExitIcon, preservesFills: false },
  'expand': { Component: ExpandIcon, preservesFills: false },
  'explore': { Component: ExploreIcon, preservesFills: false },
  'export': { Component: ExportIcon, preservesFills: false },
  'external-link': { Component: ExternalLinkIcon, preservesFills: false },
  'eye': { Component: EyeIcon, preservesFills: false },
  'face-with-sweat': { Component: FaceWithSweatIcon, preservesFills: true },
  'favorite': { Component: FavoriteIcon, preservesFills: false },
  'feedback': { Component: FeedbackIcon, preservesFills: false },
  'file-audio': { Component: FileAudioIcon, preservesFills: false },
  'file-doc': { Component: FileDocIcon, preservesFills: false },
  'file-document': { Component: FileDocumentIcon, preservesFills: false },
  'file-image': { Component: FileImageIcon, preservesFills: false },
  'file-link-content': { Component: FileLinkContentIcon, preservesFills: false },
  'file-pdf': { Component: FilePdfIcon, preservesFills: false },
  'file-text': { Component: FileTextIcon, preservesFills: false },
  'file-text-fill': { Component: FileTextFillIcon, preservesFills: false },
  'file-video': { Component: FileVideoIcon, preservesFills: false },
  'filter': { Component: FilterIcon, preservesFills: false },
  'filters': { Component: FiltersIcon, preservesFills: false },
  'fire': { Component: FireIcon, preservesFills: false },
  'fixed-layout': { Component: FixedLayoutIcon, preservesFills: false },
  'flag': { Component: FlagIcon, preservesFills: false },
  'flame': { Component: FlameIcon, preservesFills: false },
  'folder': { Component: FolderIcon, preservesFills: false },
  'folder-add': { Component: FolderAddIcon, preservesFills: false },
  'frame': { Component: FrameIcon, preservesFills: false },
  'fullscreen': { Component: FullscreenIcon, preservesFills: false },
  'gallery': { Component: GalleryIcon, preservesFills: false },
  'genially': { Component: GeniallyIcon, preservesFills: false },
  'geography': { Component: GeographyIcon, preservesFills: false },
  'global-educa': { Component: GlobalEducaIcon, preservesFills: true },
  'globe-showing-europe-africa': { Component: GlobeShowingEuropeAfricaIcon, preservesFills: true },
  'globe-with-meridians': { Component: GlobeWithMeridiansIcon, preservesFills: true },
  'go-steam': { Component: GoSteamIcon, preservesFills: true },
  'google': { Component: GoogleIcon, preservesFills: true },
  'google-calendar': { Component: GoogleCalendarIcon, preservesFills: true },
  'google-classroom': { Component: GoogleClassroomIcon, preservesFills: true },
  'google-drive': { Component: GoogleDriveIcon, preservesFills: true },
  'grades': { Component: GradesIcon, preservesFills: false },
  'gradient-star': { Component: GradientStarIcon, preservesFills: true },
  'graph-activity': { Component: GraphActivityIcon, preservesFills: false },
  'graphic': { Component: GraphicIcon, preservesFills: false },
  'group': { Component: GroupIcon, preservesFills: false },
  'halt': { Component: HaltIcon, preservesFills: true },
  'handle': { Component: HandleIcon, preservesFills: false },
  'heart': { Component: HeartIcon, preservesFills: false },
  'heart-fill': { Component: HeartFillIcon, preservesFills: false },
  'help': { Component: HelpIcon, preservesFills: false },
  'hide': { Component: HideIcon, preservesFills: false },
  'hint': { Component: HintIcon, preservesFills: false },
  'history': { Component: HistoryIcon, preservesFills: false },
  'home': { Component: HomeIcon, preservesFills: false },
  'homework': { Component: HomeworkIcon, preservesFills: true },
  'hr': { Component: HrIcon, preservesFills: false },
  'ic_person_24px': { Component: Ic_Person_24pxIcon, preservesFills: false },
  'icon-home-link': { Component: IconHomeLinkIcon, preservesFills: false },
  'icon-plus': { Component: IconPlusIcon, preservesFills: false },
  'image': { Component: ImageIcon, preservesFills: false },
  'image-fill': { Component: ImageFillIcon, preservesFills: false },
  'inbox': { Component: InboxIcon, preservesFills: false },
  'incorrect-circle': { Component: IncorrectCircleIcon, preservesFills: true },
  'info_circle': { Component: Info_CircleIcon, preservesFills: false },
  'info-circle': { Component: InfoCircleIcon, preservesFills: false },
  'info-circle-fill': { Component: InfoCircleFillIcon, preservesFills: false },
  'kanban': { Component: KanbanIcon, preservesFills: false },
  'kanban2': { Component: Kanban2Icon, preservesFills: false },
  'key': { Component: KeyIcon, preservesFills: false },
  'key-filled': { Component: KeyFilledIcon, preservesFills: false },
  'label': { Component: LabelIcon, preservesFills: false },
  'language': { Component: LanguageIcon, preservesFills: false },
  'lateicon': { Component: LateiconIcon, preservesFills: true },
  'lesson': { Component: LessonIcon, preservesFills: false },
  'lesson-backoffice': { Component: LessonBackofficeIcon, preservesFills: false },
  'lesson-teacher': { Component: LessonTeacherIcon, preservesFills: false },
  'library': { Component: LibraryIcon, preservesFills: false },
  'light': { Component: LightIcon, preservesFills: false },
  'light_bulb': { Component: Light_BulbIcon, preservesFills: false },
  'light-bulb': { Component: LightBulbIcon, preservesFills: true },
  'lightning': { Component: LightningIcon, preservesFills: false },
  'lightning-off': { Component: LightningOffIcon, preservesFills: false },
  'lightning-outlined': { Component: LightningOutlinedIcon, preservesFills: false },
  'like': { Component: LikeIcon, preservesFills: false },
  'link': { Component: LinkIcon, preservesFills: false },
  'link_new': { Component: Link_NewIcon, preservesFills: false },
  'link-content': { Component: LinkContentIcon, preservesFills: false },
  'linux': { Component: LinuxIcon, preservesFills: false },
  'list': { Component: ListIcon, preservesFills: false },
  'loading': { Component: LoadingIcon, preservesFills: false },
  'lock': { Component: LockIcon, preservesFills: false },
  'lock2': { Component: Lock2Icon, preservesFills: false },
  'm-image': { Component: MImageIcon, preservesFills: false },
  'm-slide': { Component: MSlideIcon, preservesFills: false },
  'm-video': { Component: MVideoIcon, preservesFills: false },
  'mac': { Component: MacIcon, preservesFills: false },
  'magic-wand': { Component: MagicWandIcon, preservesFills: true },
  'magic-wand-color': { Component: MagicWandColorIcon, preservesFills: true },
  'map': { Component: MapIcon, preservesFills: true },
  'map-pin': { Component: MapPinIcon, preservesFills: false },
  'master': { Component: MasterIcon, preservesFills: true },
  'math': { Component: MathIcon, preservesFills: false },
  'maths': { Component: MathsIcon, preservesFills: false },
  'matific': { Component: MatificIcon, preservesFills: false },
  'maximize': { Component: MaximizeIcon, preservesFills: false },
  'medal': { Component: MedalIcon, preservesFills: true },
  'megaphone': { Component: MegaphoneIcon, preservesFills: false },
  'megaphone-color': { Component: MegaphoneColorIcon, preservesFills: true },
  'memo': { Component: MemoIcon, preservesFills: true },
  'menu': { Component: MenuIcon, preservesFills: false },
  'message-circle': { Component: MessageCircleIcon, preservesFills: false },
  'mic': { Component: MicIcon, preservesFills: false },
  'microphone': { Component: MicrophoneIcon, preservesFills: false },
  'microsoft': { Component: MicrosoftIcon, preservesFills: false },
  'minigame': { Component: MinigameIcon, preservesFills: false },
  'minimize': { Component: MinimizeIcon, preservesFills: false },
  'mint': { Component: MintIcon, preservesFills: false },
  'mint-post': { Component: MintPostIcon, preservesFills: false },
  'minus': { Component: MinusIcon, preservesFills: false },
  'minus-circle': { Component: MinusCircleIcon, preservesFills: false },
  'monitor': { Component: MonitorIcon, preservesFills: false },
  'more': { Component: MoreIcon, preservesFills: false },
  'more-bullets': { Component: MoreBulletsIcon, preservesFills: false },
  'more-bullets-vertical': { Component: MoreBulletsVerticalIcon, preservesFills: false },
  'move': { Component: MoveIcon, preservesFills: false },
  'move-down': { Component: MoveDownIcon, preservesFills: false },
  'move-up': { Component: MoveUpIcon, preservesFills: false },
  'msteams': { Component: MsteamsIcon, preservesFills: true },
  'multiple': { Component: MultipleIcon, preservesFills: false },
  'new': { Component: NewIcon, preservesFills: false },
  'new-square': { Component: NewSquareIcon, preservesFills: false },
  'notebook': { Component: NotebookIcon, preservesFills: false },
  'notifications': { Component: NotificationsIcon, preservesFills: false },
  'off': { Component: OffIcon, preservesFills: false },
  'off-session': { Component: OffSessionIcon, preservesFills: false },
  'one-drive': { Component: OneDriveIcon, preservesFills: true },
  'online': { Component: OnlineIcon, preservesFills: false },
  'onsite': { Component: OnsiteIcon, preservesFills: false },
  'other': { Component: OtherIcon, preservesFills: false },
  'palette': { Component: PaletteIcon, preservesFills: false },
  'panorama': { Component: PanoramaIcon, preservesFills: false },
  'pantone': { Component: PantoneIcon, preservesFills: false },
  'party': { Component: PartyIcon, preservesFills: true },
  'party-popper': { Component: PartyPopperIcon, preservesFills: true },
  'password': { Component: PasswordIcon, preservesFills: false },
  'pause': { Component: PauseIcon, preservesFills: false },
  'pause-circle': { Component: PauseCircleIcon, preservesFills: false },
  'pdf': { Component: PdfIcon, preservesFills: false },
  'pdf2': { Component: Pdf2Icon, preservesFills: false },
  'pencil': { Component: PencilIcon, preservesFills: false },
  'pencil-color': { Component: PencilColorIcon, preservesFills: true },
  'photo': { Component: PhotoIcon, preservesFills: false },
  'pin': { Component: PinIcon, preservesFills: false },
  'pin-location': { Component: PinLocationIcon, preservesFills: false },
  'pinned': { Component: PinnedIcon, preservesFills: false },
  'planet': { Component: PlanetIcon, preservesFills: false },
  'play': { Component: PlayIcon, preservesFills: false },
  'play-arrow': { Component: PlayArrowIcon, preservesFills: false },
  'play-circle': { Component: PlayCircleIcon, preservesFills: false },
  'play-circle-fill': { Component: PlayCircleFillIcon, preservesFills: false },
  'play-simple': { Component: PlaySimpleIcon, preservesFills: false },
  'pleno': { Component: PlenoIcon, preservesFills: true },
  'pleno-white': { Component: PlenoWhiteIcon, preservesFills: false },
  'plus': { Component: PlusIcon, preservesFills: false },
  'plus_circle': { Component: Plus_CircleIcon, preservesFills: false },
  'poll': { Component: PollIcon, preservesFills: false },
  'poll-1': { Component: Poll_1Icon, preservesFills: false },
  'polp': { Component: PolpIcon, preservesFills: false },
  'popup-close': { Component: PopupCloseIcon, preservesFills: false },
  'presentation': { Component: PresentationIcon, preservesFills: false },
  'primary-label': { Component: PrimaryLabelIcon, preservesFills: false },
  'primary-label-1': { Component: PrimaryLabel_1Icon, preservesFills: false },
  'primary-label-2': { Component: PrimaryLabel_2Icon, preservesFills: false },
  'primary-label-3': { Component: PrimaryLabel_3Icon, preservesFills: false },
  'print': { Component: PrintIcon, preservesFills: false },
  'profile': { Component: ProfileIcon, preservesFills: false },
  'program': { Component: ProgramIcon, preservesFills: false },
  'project3': { Component: Project3Icon, preservesFills: false },
  'publish': { Component: PublishIcon, preservesFills: false },
  'questionary': { Component: QuestionaryIcon, preservesFills: false },
  'questionmark': { Component: QuestionmarkIcon, preservesFills: true },
  'radar': { Component: RadarIcon, preservesFills: false },
  'random': { Component: RandomIcon, preservesFills: false },
  'rayo': { Component: RayoIcon, preservesFills: true },
  'redflag': { Component: RedflagIcon, preservesFills: true },
  'refresh': { Component: RefreshIcon, preservesFills: false },
  'rename': { Component: RenameIcon, preservesFills: false },
  'replay': { Component: ReplayIcon, preservesFills: false },
  'replay-history': { Component: ReplayHistoryIcon, preservesFills: false },
  'report': { Component: ReportIcon, preservesFills: false },
  'restore': { Component: RestoreIcon, preservesFills: false },
  'return': { Component: ReturnIcon, preservesFills: false },
  's-profile': { Component: SProfileIcon, preservesFills: false },
  'scheme': { Component: SchemeIcon, preservesFills: false },
  'school': { Component: SchoolIcon, preservesFills: false },
  'science': { Component: ScienceIcon, preservesFills: false },
  'search': { Component: SearchIcon, preservesFills: false },
  'send': { Component: SendIcon, preservesFills: false },
  'setting': { Component: SettingIcon, preservesFills: false },
  'settings': { Component: SettingsIcon, preservesFills: false },
  'settings-fill': { Component: SettingsFillIcon, preservesFills: false },
  'share': { Component: ShareIcon, preservesFills: false },
  'share-2': { Component: Share_2Icon, preservesFills: false },
  'smartphone': { Component: SmartphoneIcon, preservesFills: false },
  'smile-01': { Component: Smile_01Icon, preservesFills: false },
  'smile-02': { Component: Smile_02Icon, preservesFills: false },
  'smile-03': { Component: Smile_03Icon, preservesFills: false },
  'smiling': { Component: SmilingIcon, preservesFills: true },
  'sort-ascending': { Component: SortAscendingIcon, preservesFills: false },
  'sort-descending': { Component: SortDescendingIcon, preservesFills: false },
  'sparkles': { Component: SparklesIcon, preservesFills: true },
  'sport': { Component: SportIcon, preservesFills: false },
  'square-checked': { Component: SquareCheckedIcon, preservesFills: true },
  'square-unchecked': { Component: SquareUncheckedIcon, preservesFills: false },
  'star': { Component: StarIcon, preservesFills: false },
  'star-evaluable': { Component: StarEvaluableIcon, preservesFills: true },
  'star-fill': { Component: StarFillIcon, preservesFills: false },
  'star-full': { Component: StarFullIcon, preservesFills: true },
  'star-half': { Component: StarHalfIcon, preservesFills: true },
  'star-line': { Component: StarLineIcon, preservesFills: false },
  'star-outlined': { Component: StarOutlinedIcon, preservesFills: false },
  'star-round': { Component: StarRoundIcon, preservesFills: false },
  'stars': { Component: StarsIcon, preservesFills: true },
  'stars2': { Component: Stars2Icon, preservesFills: true },
  'status_error_fill': { Component: Status_Error_FillIcon, preservesFills: false },
  'status_info_fill': { Component: Status_Info_FillIcon, preservesFills: false },
  'status_success_fill': { Component: Status_Success_FillIcon, preservesFills: false },
  'status_warning_fill': { Component: Status_Warning_FillIcon, preservesFills: false },
  'stop': { Component: StopIcon, preservesFills: false },
  'stream': { Component: StreamIcon, preservesFills: false },
  'student': { Component: StudentIcon, preservesFills: false },
  'students': { Component: StudentsIcon, preservesFills: false },
  'success': { Component: SuccessIcon, preservesFills: false },
  'susto': { Component: SustoIcon, preservesFills: true },
  'switch-off': { Component: SwitchOffIcon, preservesFills: false },
  'switch-on': { Component: SwitchOnIcon, preservesFills: false },
  'tablet': { Component: TabletIcon, preservesFills: false },
  'task': { Component: TaskIcon, preservesFills: false },
  'task2': { Component: Task2Icon, preservesFills: false },
  'tatum': { Component: TatumIcon, preservesFills: true },
  'teacher': { Component: TeacherIcon, preservesFills: false },
  'teams': { Component: TeamsIcon, preservesFills: true },
  'technology-language': { Component: TechnologyLanguageIcon, preservesFills: false },
  'test': { Component: TestIcon, preservesFills: false },
  'testgroup': { Component: TestgroupIcon, preservesFills: true },
  'text': { Component: TextIcon, preservesFills: false },
  'thumb_up': { Component: Thumb_UpIcon, preservesFills: false },
  'thumbs-down-red': { Component: ThumbsDownRedIcon, preservesFills: true },
  'thumbs-up': { Component: ThumbsUpIcon, preservesFills: true },
  'thumbs-up-green': { Component: ThumbsUpGreenIcon, preservesFills: true },
  'thumbsdown': { Component: ThumbsdownIcon, preservesFills: false },
  'thumbsdown_fill': { Component: Thumbsdown_FillIcon, preservesFills: false },
  'thumbsup': { Component: ThumbsupIcon, preservesFills: false },
  'thumbsup_fill': { Component: Thumbsup_FillIcon, preservesFills: false },
  'timelapse': { Component: TimelapseIcon, preservesFills: false },
  'timer': { Component: TimerIcon, preservesFills: false },
  'to-do': { Component: ToDoIcon, preservesFills: true },
  'toggle--active': { Component: ToggleActiveIcon, preservesFills: false },
  'toggle--disabled': { Component: ToggleDisabledIcon, preservesFills: false },
  'toggle-off': { Component: ToggleOffIcon, preservesFills: true },
  'toggle-on': { Component: ToggleOnIcon, preservesFills: true },
  'tool-generator': { Component: ToolGeneratorIcon, preservesFills: false },
  'tools': { Component: ToolsIcon, preservesFills: false },
  'trash': { Component: TrashIcon, preservesFills: false },
  'trash-2': { Component: Trash_2Icon, preservesFills: false },
  'trend-down': { Component: TrendDownIcon, preservesFills: false },
  'trend-up': { Component: TrendUpIcon, preservesFills: false },
  'typing': { Component: TypingIcon, preservesFills: false },
  'upload': { Component: UploadIcon, preservesFills: false },
  'upload-file': { Component: UploadFileIcon, preservesFills: false },
  'upload-image': { Component: UploadImageIcon, preservesFills: false },
  'upload-line': { Component: UploadLineIcon, preservesFills: false },
  'user': { Component: UserIcon, preservesFills: false },
  'user-filled': { Component: UserFilledIcon, preservesFills: false },
  'user2': { Component: User2Icon, preservesFills: false },
  'useredit': { Component: UsereditIcon, preservesFills: false },
  'version_history': { Component: Version_HistoryIcon, preservesFills: false },
  'video': { Component: VideoIcon, preservesFills: false },
  'video-camera': { Component: VideoCameraIcon, preservesFills: false },
  'video-movie': { Component: VideoMovieIcon, preservesFills: false },
  'videocamera': { Component: VideocameraIcon, preservesFills: false },
  'videolesson': { Component: VideolessonIcon, preservesFills: false },
  'views': { Component: ViewsIcon, preservesFills: false },
  'visibility': { Component: VisibilityIcon, preservesFills: false },
  'visibility_off': { Component: Visibility_OffIcon, preservesFills: false },
  'visible': { Component: VisibleIcon, preservesFills: false },
  'visible-off': { Component: VisibleOffIcon, preservesFills: false },
  'volume-off': { Component: VolumeOffIcon, preservesFills: false },
  'volume-up': { Component: VolumeUpIcon, preservesFills: false },
  'warning': { Component: WarningIcon, preservesFills: false },
  'warning-circle': { Component: WarningCircleIcon, preservesFills: false },
  'warning-circle-fill': { Component: WarningCircleFillIcon, preservesFills: true },
  'weblink': { Component: WeblinkIcon, preservesFills: false },
  'wifi': { Component: WifiIcon, preservesFills: false },
  'windows': { Component: WindowsIcon, preservesFills: false },
  'wordpress_media': { Component: Wordpress_MediaIcon, preservesFills: false },
  'world': { Component: WorldIcon, preservesFills: false },
  'xapi': { Component: XapiIcon, preservesFills: false },
  'zip': { Component: ZipIcon, preservesFills: false },
  'zoom-in': { Component: ZoomInIcon, preservesFills: false },
  'zoom-out': { Component: ZoomOutIcon, preservesFills: false },
} as const satisfies Record<string, IconRegistryEntry>;

export type IconName = keyof typeof ICONS;
